import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useLocation, useNavigate } from "react-router-dom";

import PretendardText from "../atoms/text/pretendardText";
import { route } from "../../router/route";

import PCContainer from "../atoms/layout/pcContainer";
import LSBdH1HeadLine from "../molecules/text/linSeedKr/Bd/lsBdH1HeadLine";
import LineSeedKrRg from "../atoms/text/lineSeedKr/lineSeedKrRg";
import LSBdDisplay01 from "../molecules/text/linSeedKr/Bd/lsBdDisplay01";
import LSRgBody02 from "../molecules/text/linSeedKr/Rg/lsRgBody02";
import BaseInfoApi from "../../api/baseInfo.api";
import { errorHandler } from "../../util/errorHandler";

const Footer = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [baseInfoData, setBaseInfoData] = useState({
    address: "경기도 군포시 엘에스로 143, 101동 3405호",
    businessNumber: "216-64-00626",
    ceo: "이동영",
    companyName: "핀라이브",
    createdAt: "2024-11-26T18:01:54.576Z",
    csCenter1: "010-4406-1831",
    csCenter2: "평일:  10:00 ~ 17:00",
    csCenter3: "토요일, 일요일, 공휴일 휴무",
    email: "finlive2024@gmail.com",
    id: 1,
    logoOriginFileName: "Group 1410117328 (1).png",
    logoServerFileName: "basic/0a47f38d-6490-45c3-8a69-f0a846d5fdfd.png",
    membershipPrice: 20000,
    reportNumber: "제2024-안양동안-1898호",
    tel: "010-4406-1831",
    updatedAt: "2024-12-10T05:33:35.810Z",
  });

  useEffect(() => {
    baseInfoFunc();
  }, []);

  const baseInfoFunc = async () => {
    try {
      const response = await BaseInfoApi.getInfo();

      const content = response.data.data.content;
      if (content) setBaseInfoData(content);
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <FooterSection>
      <FooterWrapper>
        <PCContainer
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                marginBottom: 18,
              }}
            >
              <img
                onClick={() => {
                  navigate(`${route.home}`);
                }}
                style={{
                  width: 120,
                  height: 48,
                  marginRight: 20,
                  cursor: "pointer",
                  marginBottom: 4,
                }}
                src="/assets/icons/logo_g.png"
                alt="logo_g"
              />
              <MenuText
                onClick={() => {
                  navigate(`${route.customer_service_terms_use}`);
                }}
              >
                이용약관
              </MenuText>
              <MenuText
                onClick={() => {
                  navigate(`${route.customer_service_terms_privacy}`);
                }}
              >
                개인정보처리방침
              </MenuText>
              <MenuText
                onClick={() => {
                  navigate(`${route.customer_service_notice}`);
                }}
              >
                공지사항
              </MenuText>
              <MenuText
                onClick={() => {
                  navigate(`${route.customer_service_ask}`);
                }}
              >
                1:1 문의
              </MenuText>
              <MenuText
                onClick={() => {
                  navigate(`${route.customer_service_faq}`);
                }}
                style={{
                  marginRight: 0,
                }}
              >
                FAQ
              </MenuText>
            </div>

            <LineSeedKrRg
              style={{
                fontSize: 13,
                lineHeight: "19.5px",
                color: "#6F7480",
                fontWeight: 400,
              }}
            >
              {baseInfoData.companyName} ㅣ 대표 : {baseInfoData.ceo} ㅣ
              사업자등록번호 : {baseInfoData.businessNumber} <br />
              주소: {baseInfoData.address} <br />
              통신판매업신고: {baseInfoData.reportNumber} <br />
              TEL : {baseInfoData.tel} ㅣ E-MAIL : {baseInfoData.email}
              <br />
              Copyright ⓒ 2024 핀라이브 All rights reserved.
            </LineSeedKrRg>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "flex-start",
              minWidth: 300,
            }}
          >
            <LSBdH1HeadLine
              style={{
                marginBottom: 26,
                color: "#101113",
              }}
            >
              CS CENTER
            </LSBdH1HeadLine>

            <LSBdDisplay01
              style={{
                marginBottom: 21,
                color: "#101113",
              }}
            >
              {baseInfoData.csCenter1}
            </LSBdDisplay01>

            <LSRgBody02
              style={{
                color: "#575B65",
              }}
            >
              {baseInfoData.csCenter2}
              <br />
              {baseInfoData.csCenter3}
            </LSRgBody02>
          </div>
        </PCContainer>
      </FooterWrapper>
    </FooterSection>
  );
};

export default Footer;

const FooterSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 10;
  position: relative;
`;

const FooterWrapper = styled.div`
  width: 100%;
  height: 276px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-color: #f6f7f8;
`;

const MenuText = styled(LSBdH1HeadLine)`
  cursor: pointer;

  color: #6f7480;
  margin-right: 32px;

  &:hover {
    color: #0000c7;
  }
`;
